import { MuiThemeProvider } from '@material-ui/core';
import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import store from './Store';
import { theme } from './theme';

const AppWrapper = ({ children }) => {
  return (
    <Provider store={store}>
      <MuiThemeProvider theme={theme}>
        <BrowserRouter>{children}</BrowserRouter>
      </MuiThemeProvider>
    </Provider>
  );
};

export default AppWrapper;



// WEBPACK FOOTER //
// ./src/AppWrapper.jsx